import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { EndpointResponse } from '@/types/endpoints';
import type { PriceWrite, Promotion } from '@/types/pricing';
import { utils } from '@/utils';
import type { WriteRequestOptions } from '../requestOptions';

/**
 * kitchensink requires a price above zero and both dates, the end after the start. Dates are RFC 3339 with an offset.
 * Without a subscription the promotion applies to the base price.
 */
export type PromotionCreate = { subscription_id?: number; price: PriceWrite; date_start: string; date_end: string };

export const createPromotion = async (
  scope: RequestScope,
  { itemId, data }: { itemId: number; data: PromotionCreate },
  options: WriteRequestOptions
): Promise<EndpointResponse<Promotion>> => {
  try {
    const response = await scopedApi(scope).post<EndpointResponse<Promotion>>(`pricing_item/${itemId}/promotion`, data, options);
    return response.data;
  } catch (error) {
    return utils.error.handleAxiosError(error, { redactRequestData: true });
  }
};
